import qs from 'qs';
import client from './rest/AdminClient';
import { showToast } from '../stores/ToastStore';
export async function findPaymentPartners(query) {
    var _a;
    const queryString = qs.stringify(query);
    try {
        const result = await client({
            method: 'GET',
            path: `/api/payment-partners?${queryString}`,
        });
        return (((_a = result === null || result === void 0 ? void 0 : result.entity) === null || _a === void 0 ? void 0 : _a.items) || []).map((item) => (Object.assign(Object.assign({}, item), { _type: 'Partner' })));
    }
    catch (e) {
        showToast('Failed to find payment partners', `Failed to find payment partners: ${e.entity.error}`, 'error');
        throw e;
    }
}
